import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { useAddRealEstateMutation, useDeleteRealEstateMutation, useEditRealEstateMutation } from "../../../redux/api/realEstate/realEstateApi";
import { EntRealEstate } from "../../../models/realEstate";
import { getCookie } from "typescript-cookie";

const useRealEstate = (modal: any, refresh?: () => void) => {
    const { t } = useTranslation();
    const { confirm } = modal;
    const [addRealEstate] = useAddRealEstateMutation();
    const [deleteRealEstate] = useDeleteRealEstateMutation();
    const [editRealEstate] = useEditRealEstateMutation();

    async function onAddRealEstate(newRealEstate: EntRealEstate): Promise<boolean> {
        try {
            let status: boolean = false;
            await addRealEstate(newRealEstate).then((response: any) => {
                  if (response.error) {
                                 const isKyrgyz = getCookie('i18next') === 'ky';
                                 const lang = isKyrgyz ? 'kg' : 'ru';
                                 const res = response.error.data?.res;
                                 const errorMessages = Array.isArray(res)
                                     ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                     : response.error.data?.msg || t('unknownError'); 
                                 throw new Error(errorMessages);
                             }
                if (response.data.success) {
                    status = true;
                    message.success(t('msg.successAdd'));
                    if (refresh) refresh();
                }
            }).catch((error: any) => {
                modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    }

    async function onDeleteRealEstate(realEstate: EntRealEstate) {
        try {
            let status: boolean = false;
            confirm({
                centered: true,
                title: t('msg.confirmDeleteText'),
                okText: t('general.yes'),
                cancelText: t('general.no'),
                onOk() {
                    deleteRealEstate(realEstate.id as number).then((response: any) => {
                        if (response.error) {
                            const isKyrgyz = getCookie('i18next') === 'ky';
                            const lang = isKyrgyz ? 'kg' : 'ru';
                            const res = response.error.data?.res;
                            const errorMessages = Array.isArray(res)
                                ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                : response.error.data?.msg || t('unknownError'); 
                            throw new Error(errorMessages);
                        }
                        if (response.data.success) {
                            status = true;
                            Modal.success({ title: t('msg.successDelete') });
                            if (refresh) refresh();
                        }
                    }).catch((error: any) => {
                        Modal.error({ title: t('msg.error'), content: String(error.message) });
                    });
                }
            })
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };

    async function onEditRealEstate(editedRealEstate: EntRealEstate): Promise<boolean> {
        try {
            let status: boolean = false;
            await editRealEstate(editedRealEstate).then((response: any) => {
                if (response.error) {
                    const isKyrgyz = getCookie('i18next') === 'ky';
                    const lang = isKyrgyz ? 'kg' : 'ru';
                    const res = response.error.data?.res;
                    const errorMessages = Array.isArray(res)
                        ? res.map((error: any) => error[lang] || error.ru).join('\n')
                        : response.error.data?.msg || t('unknownError'); 
                    throw new Error(errorMessages);
                }
                if (response.data.success) {
                    status = true;
                    Modal.success({ title: t('msg.successEdited') });
                    if (refresh) refresh();
                }
            }).catch((error: any) => {
                Modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };

    return { onAddRealEstate, onDeleteRealEstate, onEditRealEstate };
}

export { useRealEstate };
